import React, { useEffect, useState } from "react";
import { Card, Col, Row, Button, Form, Container } from "react-bootstrap";
import { useUsersStore } from '../../hooks/Users/useUsersStore';

export default function Standard() {
  // Estados para manejar los datos del formulario
  const [data, setData] = useState({});
  const [id, setId] = useState(0);
  const [identification, setIdentification] = useState('');
  const [name, setName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [img, setImg] = useState(null);
  const [premium, setPremium] = useState(0);
  const [companyId, setCompanyId] = useState(0);
  const [companyName, setCompanyName] = useState('');
  const [premiumTypeId, setPremiumTypeId] = useState(0);
  const [telefono, setTelefono] = useState('');
  const [estadoProvincia, setEstadoProvincia] = useState('');
  const [pais, setPais] = useState('');
  const [description, setDescription] = useState('');
  const [address, setAddress] = useState('');
  const [codePostal, setCodePostal] = useState('');
  const [companyPhone, setCompanyPhone] = useState('');
  const [companyEmail, setCompanyEmail] = useState('');
  const [type, setType] = useState('');

  const { getDataUpdateUser, UpsertUserInfoData } = useUsersStore();

  // Cargar los datos del API al montar el componente
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const response = await getDataUpdateUser();
      if (response) {
        const userData = response[0];
        setData(userData);
        setId(userData.id || 0);
        setIdentification(userData.identification || '');
        setName(userData.name || '');
        setLastName(userData.lastName || '');
        setEmail(userData.email || '');
        setImg(userData.img || null);
        setPremium(userData.premium || 0);
        setCompanyId(userData.company_id || 0);
        setCompanyName(userData.nomnbre_empresa || '');
        setPremiumTypeId(userData.premium_type_id || 0);
        setTelefono(userData.telefono || '');
        setEstadoProvincia(userData.estadoProvincia || '');
        setPais(userData.pais || '');
        setDescription(userData.description || '');
        setAddress(userData.address || '');
        setCodePostal(userData.code_postal || '');
        setCompanyPhone(userData.company_phone || '');
        setCompanyEmail(userData.company_email || '');
        setType(userData.type || '');
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  // Manejar el envío del formulario
  const handleFormSubmit = (event) => {
    event.preventDefault();
    const updatedData = {
      id: id,
      name: name,
      lastName: lastName,
      email: email,
      company_id: companyId,
      telefono: telefono,
      estadoProvincia: estadoProvincia,
      nomnbre_empresa: companyName,
      description : description,
      address: address,
      code_postal: codePostal,
      company_phone: companyPhone,
      company_email: companyEmail,
    };
    UpsertUserInfoData(updatedData); // Enviar los datos actualizados al servidor
  };

  return (
    <React.Fragment>
      <Container fluid="md">
        <div className="main-app mt-0 p-lg-4">
          <Card.Body>
            <Form onSubmit={handleFormSubmit}>
              <h1>Mi Información</h1>
              <Row className="g-4">
                {/* Inputs para cada campo */}
                <Form.Group as={Col} md="4">
                  <Form.Label>Identificación:</Form.Label>
                  <Form.Control
                    type="text"
                    value={identification}
                    onChange={(e) => setIdentification(e.target.value)}
                    required
                    disabled
                  />
                </Form.Group>

                <Form.Group as={Col} md="4">
                  <Form.Label>Nombre:</Form.Label>
                  <Form.Control
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group as={Col} md="4">
                  <Form.Label>Apellido:</Form.Label>
                  <Form.Control
                    type="text"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group as={Col} md="4">
                  <Form.Label>Email:</Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled
                  />
                </Form.Group>

                <Form.Group as={Col} md="4">
                  <Form.Label>Teléfono:</Form.Label>
                  <Form.Control
                    type="text"
                    value={telefono}
                    onChange={(e) => setTelefono(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group as={Col} md="4">
                  <Form.Label>Pais:</Form.Label>
                  <Form.Control
                    type="text"
                    value={pais}
                    onChange={(e) => setPais(e.target.value)}
                    required
                    disabled
                  />
                </Form.Group>

                <Form.Group as={Col} md="4">
                  <Form.Label>Estado/Provincia:</Form.Label>
                  <Form.Control
                    type="text"
                    value={estadoProvincia}
                    onChange={(e) => setEstadoProvincia(e.target.value)}
                    required
                  />
                </Form.Group>

                <hr />
                <h1>Información de Empresa</h1>
                <Form.Group as={Col} md="4">
                  <Form.Label>Nombre Empresa:</Form.Label>
                  <Form.Control
                    type="text"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    required
                  />
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label>Descripción Empresa:</Form.Label>
                  <Form.Control
                    type="text"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group as={Col} md="4">
                  <Form.Label>Dirección Empresa:</Form.Label>
                  <Form.Control
                    type="text"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group as={Col} md="4">
                  <Form.Label>Código Postal:</Form.Label>
                  <Form.Control
                    type="text"
                    value={codePostal}
                    onChange={(e) => setCodePostal(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group as={Col} md="4">
                  <Form.Label>Teléfono de la Empresa:</Form.Label>
                  <Form.Control
                    type="text"
                    value={companyPhone}
                    onChange={(e) => setCompanyPhone(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group as={Col} md="4">
                  <Form.Label>Email de la Empresa:</Form.Label>
                  <Form.Control
                    type="email"
                    value={companyEmail}
                    onChange={(e) => setCompanyEmail(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group as={Col} md="4">
                  <Form.Label>Tipo:</Form.Label>
                  <Form.Control
                    type="text"
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                    disabled
                    required
                  />
                </Form.Group>
              </Row>
              <hr />
              <div>
                <Col sm="12">
                  <Button type="submit" variant="success" className="btn-sign">
                    Guardar
                  </Button>
                </Col>
              </div>
            </Form>
          </Card.Body>
        </div>
      </Container>
    </React.Fragment>
  );
}